<template>
  <div class="consistenze">
    <table class="table-auto w-full text-xs">
      <thead class="bg-gray-200">
      <tr>
        <th class="text-left px-2 md:px-4">Descrizione</th>
        <th class="text-left px-2 md:px-4"></th>
      </tr>
      </thead>
      <tbody>
          <tr v-for="(row, index) in rows" :key="index">
            <td class="border px-1 md:px-4 py-2">
              {{row.etichetta}}
            </td>
            <td class="border px-1 md:px-4 py-2">
              <template v-if="row.tipo === 'string'">
                {{row.valore}}
              </template>
              <template v-else>
                <input type="checkbox" :checked="row.valore" disabled>
              </template>
            </td>
          </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "Caratteristiche",
  props: ['consistenze'],
  computed: {
    rows() {
      return this.consistenze.map(c => ({
        etichetta: c.Descrizione ? c.Descrizione.Voce : c.Etichetta,
        tipo: !c.Descrizione ? 'string' : c.Descrizione.TipoContenuto !== 1 ? 'string' : 'checkbox',
        valore: !c.Descrizione ? c.ValoreText : c.Descrizione.TipoContenuto !== 1 ? c.ValoreText : c.ValoreBool
      }))
    }
  }
}
</script>

<style scoped>

</style>
